import React from 'react';
import { BadgeCheck, ChevronRight, Cctv, CloudUpload, Database, FileDown, Globe, Mail, Printer, QrCode, ScanLine, ScanText, ShieldAlert, Smartphone, Stamp, UserCheck, Users } from 'lucide-react';
import { toBn } from '../../utils/bangla';
const phases = [{
  title: 'বিদ্যমান AI প্রসিকিউশন ব্যবস্থা',
  color: '#5b6b80',
  note: 'বর্তমানে চালু — অপরিবর্তিত থাকবে',
  steps: [{
    icon: Cctv,
    bn: 'AI ক্যামেরা শনাক্তকরণ',
    en: 'AI Camera Detection'
  }, {
    icon: Database,
    bn: 'স্বয়ংক্রিয় মামলা রুজু',
    en: 'Automated Case Filing'
  }, {
    icon: Printer,
    bn: 'SMS ও মূল নোটিশ মুদ্রণ',
    en: 'SMS & Original Notice Printing'
  }]
}, {
  title: 'ডিজিটাইজেশন ও AI/OCR',
  color: '#1769AA',
  note: 'প্রস্তাবিত প্ল্যাটফর্ম',
  steps: [{
    icon: ScanLine,
    bn: 'স্ক্যান / আপলোড / মোবাইল ক্যাপচার',
    en: 'Scan / Upload / Mobile Capture'
  }, {
    icon: CloudUpload,
    bn: 'নিরাপদ ডকুমেন্ট আপলোড',
    en: 'Secure Document Upload'
  }, {
    icon: ScanText,
    bn: 'AI/OCR তথ্য সংগ্রহ',
    en: 'AI/OCR Data Extraction'
  }]
}, {
  title: 'যাচাই, অনুমোদন ও নিরাপদ নোটিশ',
  color: '#003B71',
  note: 'মেকার-চেকার নিয়ন্ত্রণ',
  steps: [{
    icon: UserCheck,
    bn: 'কর্মকর্তা কর্তৃক যাচাই',
    en: 'Officer Validation'
  }, {
    icon: Stamp,
    bn: 'তত্ত্বাবধায়ক অনুমোদন',
    en: 'Supervisory Approval'
  }, {
    icon: QrCode,
    bn: 'নিরাপদ QR নোটিশ তৈরি',
    en: 'Secure QR Notice Generation'
  }, {
    icon: Mail,
    bn: 'প্রিন্ট ও ডাকযোগে প্রেরণ',
    en: 'Print & Postal Dispatch'
  }]
}, {
  title: 'নাগরিক যাচাই',
  color: '#006A4E',
  note: 'লগইন ছাড়াই',
  steps: [{
    icon: Users,
    bn: 'নাগরিক নোটিশ গ্রহণ',
    en: 'Citizen Receives Notice'
  }, {
    icon: Smartphone,
    bn: 'QR স্ক্যান',
    en: 'Citizen Scans QR'
  }, {
    icon: BadgeCheck,
    bn: 'দ্রুত যাচাই ফলাফল',
    en: 'Quick Verification Result'
  }, {
    icon: Globe,
    bn: 'অফিসিয়াল ডিএমপি যাচাই পেজ',
    en: 'Official DMP Verification Page'
  }, {
    icon: FileDown,
    bn: 'অফিসিয়াল নোটিশ দেখুন / ডাউনলোড',
    en: 'View / Download Notice'
  }, {
    icon: ShieldAlert,
    bn: 'প্রতারণা রিপোর্ট (প্রয়োজনে)',
    en: 'Report Fraud (if necessary)'
  }]
}];
export function ProcessDiagram() {
  let n = 0;
  return <div className="space-y-5" data-id="element-608" data-mp="1qn5ppqp3tjsw">
      {phases.map(p => <section key={p.title} className="rounded-xl border bg-white p-5" style={{
      borderColor: `${p.color}40`
    }} data-id="element-609" data-mp="1vfqkaufu40xh">
          <header className="mb-4 flex flex-wrap items-center gap-3" data-id="element-610" data-mp="20didrsw4nv3s">
            <span className="rounded-md px-3 py-1 text-sm font-bold text-white" style={{
          backgroundColor: p.color
        }} data-id="element-611" data-mp="24fm0jdo8ym4d">{p.title}</span>
            <span className="text-xs text-slate-500" data-id="element-612" data-mp="29gjflhdyn01n">{p.note}</span>
          </header>
          <ol className="flex flex-wrap items-stretch gap-y-4" data-id="element-613" data-mp="2ed9vo4prlvn2">
            {p.steps.map((s, i) => {
          n += 1;
          const Icon = s.icon;
          return <li key={s.en} className="flex min-w-[170px] flex-1 items-center" data-id="element-614" data-mp="jzs84hpd0ys1" data-mpi={i}>
                  <div className="flex h-full flex-1 flex-col items-center rounded-lg bg-[#F4F7FB] px-3 py-4 text-center" data-id="element-615" data-mp="cgiwehtdsnzt">
                    <div className="relative" data-id="element-616" data-mp="7pstrcccaz8t">
                      <span className="flex h-14 w-14 items-center justify-center rounded-full text-white" style={{
                  backgroundColor: p.color
                }} data-id="element-617" data-mp="7nzj7lylvuvj">
                        <Icon className="h-7 w-7" data-id="element-618" data-mp="3ty24c2hlgyen" />
                      </span>
                      <span className="absolute -right-1 -top-1 flex h-6 w-6 items-center justify-center rounded-full border-2 border-white bg-[#E69A20] text-[11px] font-bold text-white" data-id="element-619" data-mp="vfd9lmd75gdv">{toBn(n)}</span>
                    </div>
                    <div className="mt-3 text-sm font-semibold leading-snug text-slate-800" data-id="element-620" data-mp="lgfrb16d6j3b">{s.bn}</div>
                    <div className="mt-0.5 text-[11px] text-slate-500" data-id="element-621" data-mp="ghcmnhuaqevv">{s.en}</div>
                  </div>
                  {i < p.steps.length - 1 && <ChevronRight className="mx-1 h-5 w-5 shrink-0" style={{
              color: p.color
            }} data-id="element-622" data-mp="365lj5j2k8qb4" />}
                </li>;
        })}
          </ol>
        </section>)}
    </div>;
}